import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import ListIcon from "@mui/icons-material/List";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import CategoryIcon from '@mui/icons-material/Category';
import { Box, Typography } from "@mui/material";
import FileOpenIcon from '@mui/icons-material/FileOpen';
import { APP_ROUTES } from "../../../config/appRoutes";
import { getFileClinetsThunk, getFileUsersThunk, getCategoriesThunk } from "../filesThunk";
import { useDispatch } from "react-redux";
import { getButtonStyles } from '../../../components/featureButtonStyles/buttonStyles';
import { resetFileState } from "../filesSlice";
import FolderIcon from '@mui/icons-material/Folder';

export default function PageButtons() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [activePath, setActivePath] = useState(location.pathname);
  const [expanded, setExpanded] = useState("Branch"); // default UI state

  const sections = [
    { label: "Files", routes: APP_ROUTES.FILES, icon: <FileOpenIcon /> },
    { label: "Category", routes: APP_ROUTES.CATEGORY, icon: <CategoryIcon /> },
  ];

  const knownPaths = new Set(
    sections.flatMap((s) => [s.routes.LIST, s.routes.CREATION])
  );

  useEffect(() => {
    if (!knownPaths.has(location.pathname)) {
      navigate(APP_ROUTES.BRANCH.LIST, { replace: true });
      setActivePath(APP_ROUTES.BRANCH.LIST);
      setExpanded("Branch");
    } else {
      setActivePath(location.pathname);
    }

  }, []);

  useEffect(() => {
    setActivePath(location.pathname);
    const match = sections.find(
      (s) =>
        location.pathname === s.routes.LIST ||
        location.pathname === s.routes.CREATION
    );
    if (match) setExpanded(match.label);
  }, [location.pathname]);

  const handleClick = (path) => { navigate(path); dispatch(resetFileState()) };


  useEffect(() => {
    dispatch(getFileClinetsThunk());
    dispatch(getFileUsersThunk());
    dispatch(getCategoriesThunk());
  }, [dispatch]);


  return (
    <Box display="flex" flexDirection="column" gap="16px">

      {/* <Box display="flex" alignItems="center" marginBottom="16px" gap="8px">
        <FolderIcon style={{ color: "var(--primary)" }} />
        <Typography variant="h6" style={{ fontWeight: 800, color: "var(--btn-12)" }}>
          File & Category
        </Typography>
      </Box> */}

      <Box display="flex" gap="16px" mt={4}>
        {sections.map((section) => {
          const isSectionActive =
            activePath === section.routes.LIST ||
            activePath === section.routes.CREATION;

          return (
            <Button
              key={section.label}
              variant="outlined"
              onClick={() => handleClick(section.routes.LIST)} // always go to List on switch
              sx={getButtonStyles(isSectionActive, "top")}
              startIcon={section.icon} // ✅ added icon here
            >
              {section.label}
            </Button>
          );
        })}
      </Box>

      {/* Actions for the expanded section */}
      {sections.map(
        (section) =>
          expanded === section.label && (
            <Box
              key={`${section.label}-actions`}
              display="flex"
              gap="12px"
              pl={2}
            >
              <Button
                variant="outlined"
                onClick={() => handleClick(section.routes.LIST)}
                sx={getButtonStyles(activePath === section.routes.LIST, "bottom")}
                startIcon={<ListIcon />}
              >
                List
              </Button>
              <Button
                variant="outlined"
                onClick={() => handleClick(section.routes.CREATION)}
                sx={getButtonStyles(activePath === section.routes.CREATION, 'bottom')}
                startIcon={<PersonAddIcon />}
              >
                Creation
              </Button>
            </Box>
          )
      )}
    </Box>
  );
}
